import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/balance-2.png'


const _hoisted_1 = { class: "card bg-primary-div bg-opacity-10 border-0 rounded-3 p-4 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_0 + "\" alt=\"balance\"></div><div class=\"flex-grow-1 ms-2\"><span class=\"mb-1 d-block fw-medium text-body\">GROSS EARNINGS</span><div class=\"d-flex\"><h3 class=\"mb-0 fs-20 fw-semibold me-1\">$78,350.00</h3><i class=\"material-symbols-outlined fs-16 position-relative top-3 text-success\"> trending_up </i><span class=\"text-success\">+2.3%</span></div></div></div>", 1)),
    (_ctx.isClient)
      ? (_openBlock(), _createBlock(_component_apexchart, {
          key: 0,
          type: "line",
          height: "207",
          options: _ctx.grossEarnings,
          series: _ctx.earnings
        }, null, 8, ["options", "series"]))
      : _createCommentVNode("", true),
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"d-flex justify-content-between pt-4 for-dark-border\" style=\"border-top:1px solid #e9d5ff;\"><div><span class=\"fs-14 d-block mb-1\">Total Balance</span><h3 class=\"fs-20 fw-medium mb-0\">$3,42,890</h3></div><div><span class=\"fs-14 d-block mb-1\">Withdrawals</span><h3 class=\"fs-20 fw-medium mb-0\">$2,35,425</h3></div></div>", 1))
  ]))
}